import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sxaBtn"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-sxa-accessibility" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "sxAccessibility__content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sxAccessibility", [
      _ctx.position ? 'sxAccessibility--' + _ctx.position : '',
      _ctx.anchor ? 'sxAccessibility--' + _ctx.anchor : '',
      _ctx.state.accessibilityVisible ? 'sxAccessibility--visible' : '',
    ]])
  }, [
    _createElementVNode("div", {
      class: "sxAccessibility__trigger",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuToggleAction && _ctx.onMenuToggleAction(...args)))
    }, [
      (_ctx.$slots.trigger)
        ? _renderSlot(_ctx.$slots, "trigger", { key: 0 })
        : (_openBlock(), _createElementBlock("button", _hoisted_1, _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "sxAccessibility__close",
        style: _normalizeStyle([
          _ctx.backgroundcolor ? { backgroundColor: _ctx.backgroundcolor } : '',
          _ctx.color ? { color: _ctx.color } : '',
        ]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMenuToggleAction && _ctx.onMenuToggleAction(...args)))
      }, _toDisplayString(_ctx.t("header.accessibility.close")), 5),
      (_ctx.state.accessibilityList)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.accessibilityList, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["sxaBtn sxaBtn--block", { 'is-active': item.active }]),
                  onClick: ($event: any) => (_ctx.onSetupAccessibilityMode(index))
                }, [
                  (item.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(item.icon)
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(item.title), 1)
                ], 10, _hoisted_6)
              ]))
            }), 128)),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.accessibilityFontList, (item, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    class: _normalizeClass(["sxaBtn", { 'is-active': item.active }]),
                    onClick: ($event: any) => (_ctx.onChangeFontSizeClick(index))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(item.spanClass)
                    }, _toDisplayString(item.title), 3)
                  ], 10, _hoisted_7))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "sxaBtn sxaBtn--sm sxaBtn--link",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onRemoveAllCookiesClick && _ctx.onRemoveAllCookiesClick(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.t("header.accessibility.reset")), 1)
      ])
    ])
  ], 2))
}